import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import ArrowUp from '@common/images/Arrow-Up.svg';
import style from './style.module.scss';

export function GoBackIcon(props) {
  const className = `${style.icon} ${props.className}`;
  return <Image className={className} src={ArrowUp} alt='Go back' />;
}

GoBackIcon.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

GoBackIcon.defaultProps = {
  className: '',
};
